<form
  class="position-relative d-flex flex-column gap-3"
  [formGroup]="device_form"
  [tds-data-loader]="{ key: 'devices-creation-form', as_overlay: true, delay: 500 }"
  (ngSubmit)="createDevice()"
>
  <div>
    <label for="productCategory" class="form-label required">
      {{ 'product_category' | translate }}
    </label>
    <select
      id="productCategory"
      class="form-select cursor-pointer"
      formControlName="category"
      [class.is-invalid]="isFieldValid('category')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('category') ? 'categoryValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      @for (category of device_characteristics.category; track category) {
        <option [value]="category.id">
          {{ category.name }}
        </option>
      }
    </select>
    @if (isFieldValid('category')) {
      <div id="categoryValidationFeedback" class="invalid-feedback d-block">
        {{ 'choose_a_product_category' | translate }}
      </div>
    }
  </div>

  <div>
    <label for="deviceBrand" class="form-label required">{{ 'brand' | translate }}</label>
    <select
      id="deviceBrand"
      class="form-select cursor-pointer"
      formControlName="brand"
      [class.is-invalid]="isFieldValid('brand')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('brand') ? 'brandValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      @for (brand of device_characteristics.brand; track brand) {
        <option [value]="brand.id">
          {{ brand.name }}
        </option>
      }
    </select>
    @if (isFieldValid('brand')) {
      <div id="brandValidationFeedback" class="invalid-feedback d-block">
        {{ 'choose_a_brand' | translate }}
      </div>
    }
  </div>

  <div>
    <label for="deviceModel" class="form-label required">
      {{ 'model' | translate }}
    </label>
    <select
      id="deviceModel"
      class="form-select cursor-pointer"
      formControlName="model"
      [class.is-invalid]="isFieldValid('model')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('model') ? 'modelValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      @for (model of device_characteristics.model; track model) {
        <option [value]="model.id">
          {{ model.name }}
        </option>
      }
    </select>
    @if (isFieldValid('model')) {
      <div id="modelValidationFeedback" class="invalid-feedback d-block">
        {{ 'choose_a_model' | translate }}
      </div>
    }
  </div>

  <div>
    <label for="deviceColor" class="form-label required">
      {{ 'color' | translate }}
    </label>
    <select
      id="deviceColor"
      class="form-select cursor-pointer"
      formControlName="color"
      [class.is-invalid]="isFieldValid('color')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('color') ? 'colorValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      @for (color of device_characteristics.color; track color) {
        <option [value]="color.id">
          {{ color.name }}
        </option>
      }
    </select>
    @if (isFieldValid('color')) {
      <div id="colorValidationFeedback" class="invalid-feedback d-block">
        {{ 'choose_a_color' | translate }}
      </div>
    }
  </div>

  <div>
    <label for="deviceStorage" class="form-label required">
      {{ 'storage' | translate }}
    </label>
    <select
      id="deviceStorage"
      class="form-select cursor-pointer"
      formControlName="storage"
      [class.is-invalid]="isFieldValid('storage')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('storage') ? 'storageValidationFeedback' : undefined"
    >
      <option value="">{{ 'select' | translate }}</option>
      @for (storage of device_characteristics.storage; track storage) {
        <option [value]="storage.id">
          {{ storage.name }}
        </option>
      }
    </select>
    @if (isFieldValid('storage')) {
      <div id="storageValidationFeedback" class="invalid-feedback d-block">
        {{ 'choose_a_storage_size' | translate }}
      </div>
    }
  </div>

  <div>
    <label for="deviceImei" class="form-label required">
      {{ 'imei' | translate }}
    </label>
    <input
      id="deviceImei"
      class="form-control"
      type="text"
      formControlName="imei"
      restrict-input="no_empty_space"
      [class.is-invalid]="isFieldValid('imei')"
      [required]="true"
      [attr.aria-describedby]="isFieldValid('imei') ? 'imeiValidationFeedback' : undefined"
    />
    @if (isFieldValid('imei')) {
      <div id="imeiValidationFeedback" class="invalid-feedback d-block">
        @if (device_form.controls['imei'].errors!['required']) {
          <span>
            {{ 'choose_an_imei' | translate }}
          </span>
        }
        @if (device_form.controls['imei'].errors!['error']) {
          <span>
            {{ device_form.controls['imei'].errors!['error'] }}
          </span>
        }
      </div>
    }
  </div>

  <div>
    <label for="deviceSerialNumber" class="form-label required">
      {{ 'serial_number' | translate }}
    </label>
    <input
      id="deviceSerialNumber"
      class="form-control"
      type="text"
      formControlName="serial_number"
      restrict-input="no_empty_space"
      [class.is-invalid]="isFieldValid('serial_number')"
      [required]="true"
      [attr.aria-describedby]="
        isFieldValid('serial_number') ? 'serialNumberValidationFeedback' : undefined
      "
    />
    @if (isFieldValid('serial_number')) {
      <div id="serialNumberValidationFeedback" class="invalid-feedback d-block">
        @if (device_form.controls['serial_number'].errors!['required']) {
          <span>
            {{ 'choose_a_serial_number' | translate }}
          </span>
        }
        @if (device_form.controls['serial_number'].errors!['error']) {
          <span>
            {{ device_form.controls['serial_number'].errors!['error'] }}
          </span>
        }
      </div>
    }
  </div>

  <button class="btn btn-primary w-100" type="submit" [disabled]="device_form.invalid">
    {{ 'continue' | translate }}
  </button>
</form>
